<template>
  <layout-basic>
    <be-table
      :fields="fields"
      :actions="actions"
      card-name="Drivers"
      order-by="firstName"
      base-url="drivers"
      :header-buttons="buttons"
      :refresh="refreshData"
      @refreshed="refreshData = false"
    />
    <be-create-edit-modal
      v-model="driverToEdit"
      modal-name="New Driver"
      :fields="modalFields"
      :open="modalOpen"
      url="drivers"
      :edit-mode="modalEditMode"
      @modal-closed="onModalClose"
    />
  </layout-basic>
</template>

<script>
  import LayoutBasic from "@/layouts/LayoutBasic";
  import BeTable from "../components/crud/BeTable";
  import BeCreateEditModal from "../components/crud/BeCreateEditModal";
  import {required} from "vuelidate/lib/validators";

  const phoneValidation = (value) => /^\+[1-9]\d{1,14}$/.test(value)

  export default {
    name: "Drivers",
    components: {
      LayoutBasic,
      BeTable,
      BeCreateEditModal
    },
    data() {
      return {
        fields: [
          {key: "firstName", sortable: true},
          "lastName",
          "phoneNumber",
          {
            key: "actions",
            label: ""
          }
        ],
        buttons: [],
        actions: [],
        refreshData: true,
        modalFields: [],
        modalOpen: false,
        driverToEdit: null,
        modalEditMode: false
      };
    },
    created() {
      let vm = this;
      this.buttons = [
        {
          title: '+ New Driver',
          variant: 'primary',
          callback: function () {
            vm.modalOpen = true
          }
        }
      ];
      this.actions = [
        {
          class: 'table-edit',
          icon: 'fa fa-external-link-alt',
          callback: function (item) {
            vm.driverToEdit = item;
            vm.modalEditMode = true;
            vm.modalOpen = true
          }
        },
        {
          class: 'table-viber',
          icon: 'fab fa-viber',
          classCallback: (item) => item.viberId ? "table-viber text-success" : "table-viber text-secondary",
          callback: async function (item) {
            try {
              let response = await vm.$http.get(`drivers/${item.id}/viberInvite`);
              vm.successAlert('The driver\'s Viber invitation link has been sent to you via Viber. Please forward it to the driver.')
            } catch (error) {
              vm.handleErrorResponse(error);
            }
          }
        },
        {
          class: 'table-delete',
          icon: 'fa fa-trash-alt',
          callback:async function (item) {
            try{
              let confirmation = await vm.$bvModal.msgBoxConfirm('Are you sure you want to delete this driver?', {
                okVariant: 'danger',
                okTitle: 'Delete',
              });
              if (!confirmation) return;
              let response = await vm.$http.delete(`drivers/${item.id}`);
              vm.refreshData = true;
            }catch(error){
              vm.handleErrorResponse(error);
            }
          }
        }
      ]
      this.modalFields = [
        {
          name: "firstName",
          label: "Driver First Name",
          type: "text",
          placeholder: "Enter first name",
          validations: {required},
          validationError: "Driver first name is required"
        },
        {
          name: "lastName",
          label: "Driver Last Name",
          type: "text",
          placeholder: "Enter last name",
          validations: {required},
          validationError: "Driver last name is required"
        },
        {
          name: "phoneNumber",
          label: "Driver Phone",
          type: "text",
          placeholder: "Enter phone number",
          validations: {required, phoneValidation},
          validationError: "Phone number is required and should be in international format starting with +"
        },
        {
          name: "hidden",
          label: "Hidden?",
          type: "checkbox",
          editOnly: true,
          validations: {},
          validationError: ""
        },
        {
          name: "viberInvite",
          label: "Invite driver to Viber",
          type: "callbackCheckbox",
          validations: {},
          validationError: "",
          createOnly: true,
          callback: async (item)=>{
            try {
              let response = await vm.$http.get(`drivers/${item.id}/viberInvite`);
              vm.successAlert('The driver\'s Viber invitation link has been sent to you via Viber. Please forward it to the driver.')
            } catch (error) {
              vm.handleErrorResponse(error);
            }
          }
        },
      ]
    },
    methods: {
      onModalClose() {
        this.modalOpen = false
        this.modalEditMode = false
        this.driverToEdit = null
        this.refreshData = true
      }
    }
  };
</script>

<style lang="scss" scoped>
  @import "@/assets/variables.scss";
  @import "bootstrap/scss/_functions.scss";
  @import "bootstrap/scss/_variables.scss";
  @import "bootstrap/scss/_mixins.scss";

  .data-card .card-body {
    padding: 0px;
  }

  .data-card .card-header {
    padding-left: 12px;
    padding-right: 12px;

    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    @include media-breakpoint-down(sm) {
      padding-left: 0px;
    }
  }

  .data-card .card-header > * {
    &:not(:first-child) {
      margin-left: 12px;
    }

    @include media-breakpoint-down(sm) {
      margin-bottom: 6px;
    }
  }

  h4 {
    @include media-breakpoint-down(sm) {
      flex-basis: 100%;
      margin-left: 12px;
    }
  }

  .search-field {
    flex-basis: 25%;

    @include media-breakpoint-down(sm) {
      flex-basis: auto;
      flex-grow: 1;
      width: auto;
      order: 1;
    }
  }

  /deep/ .tb-col-narrow {
    width: 75px !important;
  }

</style>